import { Link } from 'react-router-dom';
import useReveal from '../components/useReveal';
import { works } from '../data/works';
import { usePosts } from '../hooks/usePosts';

function Reveal({ children, delay = 0, className = '' }) {
  const ref = useReveal();
  return <div ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }}>{children}</div>;
}

export default function Blog() {
  const { posts, loading, error } = usePosts();

  if (loading) {
    return <div className="pt-32 px-20 text-stone-muted">Loading...</div>;
  }

  if (error) {
    return <div className="pt-32 px-20 text-stone-muted">Error loading posts: {error}</div>;
  }

  const writings = posts
    .filter(p => p.title && p.date)
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  if (!writings.length) {
    return <div className="pt-32 px-20 text-stone-muted">No posts found.</div>;
  }

  return (
    <div className="pt-16">

      {/* Header */}
      <div className="px-10 md:px-16 lg:px-20 py-20 border-b border-cream-400/60 grid grid-cols-1 md:grid-cols-2 gap-12">
        <Reveal>
         
          <h1 className="font-serif text-5xl md:text-6xl font-normal text-ink leading-tight">
            Blogs<br />
          </h1>
        </Reveal>
        <Reveal delay={150} className="flex items-end">
          <p className="font-sans text-base text-stone-warm leading-relaxed">
            Writing about making — the decisions, the failures, the moments when something
            stops being a prototype and starts being a piece. Mostly about the installations,
            sometimes just about ideas.
          </p>
        </Reveal>
      </div>

      {/* Featured post */}
  
      <div className="divide-y divide-cream-400/60">
        {writings.map((post, i) => {
          const workId = post.workId;
          const linkedInstallation = workId ? works.find(w => w.id === workId) : null;
          return (
            <Reveal key={post.id || post.slug} delay={i * 60}>
              <Link to={`/blog/${post.id || post.slug}`}
                className="group flex flex-col md:flex-row md:items-start gap-4 md:gap-12 px-10 md:px-16 lg:px-20 py-10 hover:bg-cream-200/40 transition-colors duration-200">
                <span className="font-mono text-[11px] text-stone-muted w-28 flex-shrink-0 pt-1">{post.date}</span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-serif text-2xl text-ink font-normal mb-1 group-hover:opacity-70 transition-opacity leading-snug">
                    {post.title}
                  </h3>
                  <p className="font-sans text-sm text-stone-muted mb-3 italic">{post.subtitle}</p>
                  <p className="font-sans text-sm text-stone-warm leading-relaxed mb-4 max-w-xl">{post.excerpt}</p>
                  <div className="flex gap-2 flex-wrap ">
                    {post.tags.map(t => (
                      <span key={t} className="label px-2 py-0.5 border border-cream-400/60 bg-[#F8F3D6] text-ink">{t}</span>
                    ))}
                  </div>
                  {linkedInstallation && (
                    <p className="font-sans text-xs text-stone-muted mt-3">
                      Related work: <span className="text-ink">{linkedInstallation.title}</span>
                    </p>
                  )}
                </div>
                <span className="label text-stone-muted flex-shrink-0 hidden md:block pt-1">{post.readTime} read</span>
              </Link>
            </Reveal>
          );
        })}
      </div>

    </div>
  );
}

